import { Provider } from 'mobx-react';
import { createElement } from 'react';
import { GlobalComponentsContextStore } from '@gc/global-controls-store';

/**
 * Creates and "Hydrates" empty MobX stores on the client from serialized
 * state (`__PLUGIN_STATE__`).
 * @param factories  The map of name to `StoreFactory` objects.
 * @param data       The raw (`__PLUGIN_STATE__`) to use for hydration.
 * @param logger
 */
var hydrateGlobalComponentsContext = function (data, logger) {
    return new GlobalComponentsContextStore(data, logger);
};

function GlobalComponentsContextPlugin() {
    return {
        name: 'global-components-context',
        onBrowserHydrateRenderContext: function (context, next) {
            var hydratedState = context.hydratedState, setAppData = context.setAppData, logger = context.logger;
            // hydrate serialized stores
            var globalComponentsContext = hydratedState.globalComponentsContext;
            var hydratedContext = hydrateGlobalComponentsContext(globalComponentsContext, logger);
            setAppData({ globalComponentsContext: hydratedContext });
            return next(context);
        },
        onBrowserWrapRootElement: function (context, next) {
            var getAppData = context.getAppData, setRootElement = context.setRootElement;
            setRootElement(function (RootElement) { return function (props) { return (createElement(Provider, { globalComponentsContext: getAppData().globalComponentsContext },
                createElement(RootElement, null, props.children))); }; });
            return next(context);
        }
    };
}

export default GlobalComponentsContextPlugin;
//# sourceMappingURL=browser.js.map
